import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { BlogFilterTitle } from "../../../../../Constants/Constants";
import BlogSearch from "./BlogSearch";
import TrendingPosts from "./TrendingPosts";
import FollowUs from "./FollowUs";
import RecentPosts from "./RecentPosts";
import PopularTags from "./PopularTags";
import Subscriber from "./Subscriber";

const BlogFilter = () => {
  const [open, setOpen] = useState(false);

  return (
    <Col xxl="3" xl="4" className="blog-filter">
      <div className="md-sidebar">
        <Btn color="primary" className="email-aside-toggle md-sidebar-toggle" onClick={() => setOpen(!open)}>
          {BlogFilterTitle}
        </Btn>
        <div className={`md-sidebar-aside job-sidebar custom-scrollbar ${open ? "open" : ""}`}>
          <Row className="row blog-sidebar">
            <BlogSearch />
            <TrendingPosts />
            <FollowUs />
            <RecentPosts />
            <PopularTags />
            <Subscriber />
          </Row>
        </div>
      </div>
    </Col>
  );
};

export default BlogFilter;
